var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.333 7H19.9734C20.4207 7 20.6443 7 20.7751 7.09404C20.8893 7.17609 20.9636 7.30239 20.9799 7.442C20.9986 7.602 20.8899 7.79751 20.6727 8.18851L19.3266 10.6115C19.2478 10.7533 19.2085 10.8242 19.193 10.8993C19.1793 10.9657 19.1793 11.0343 19.193 11.1007C19.2085 11.1758 19.2478 11.2467 19.3266 11.3885L20.6727 13.8115C20.8899 14.2025 20.9986 14.398 20.9799 14.558C20.9636 14.6976 20.8893 14.8239 20.7751 14.906C20.6443 15 20.4207 15 19.9734 15H12.933C12.373 15 12.0929 15 11.879 14.891C11.6909 14.7951 11.5379 14.6422 11.442 14.454C11.333 14.2401 11.333 13.9601 11.333 13.4V11M4.33301 21L4.33301 4M4.33301 11H12.733C13.2931 11 13.5731 11 13.787 10.891C13.9752 10.7951 14.1281 10.6422 14.224 10.454C14.333 10.2401 14.333 9.96005 14.333 9.4V4.6C14.333 4.03995 14.333 3.75992 14.224 3.54601C14.1281 3.35785 13.9752 3.20487 13.787 3.10899C13.5731 3 13.2931 3 12.733 3H5.93301C5.37296 3 5.09293 3 4.87902 3.10899C4.69086 3.20487 4.53787 3.35785 4.442 3.54601C4.33301 3.75992 4.33301 4.03995 4.33301 4.6V11Z",
    stroke: "#145DD7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag04);
export default __webpack_public_path__ + "static/media/flag-04.06111b29b3acd78d030d8e21e0b2e6f5.svg";
export { ForwardRef as ReactComponent };